module.exports = __webpack_public_path__ + "ca8fb1d5dda0c5269c6c1a015aae21a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Avenir-Light.ttf?v=8.0d5e4
// module id = 931
// module chunks = 24